// extracted by mini-css-extract-plugin
export default {"coinRecord":"coin-record_coinRecord__C4OZt","coinRecord__inputContainer":"coin-record_coinRecord__inputContainer__17M9N"};